import script from "./Tabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=982ebbf6&lang=scss"

const __exports__ = script;

export default __exports__